import { combineReducers } from 'redux';

import {
  CHECKIN,
  NEXT,
  NEW_CHECKIN,
  NEW_NEXT,
  MANUAL_PAYMENT,
  CHECK_PAYMENT,
  NEW_CHECK_PAYMENT,
  NEW_MANUAL_PAYMENT,
  IDASTART,
  IDANEXT,
  RANDOM_NEXT,
  LAST_NEXT,
  OFFER_CHECKIN,
  SELECT_OFFER,
  RESUME_APPLICATION,
} from '../actions/navigation';

const checkinData = (state = {}, action) => {
  switch (action.type) {
    case CHECKIN:
    case NEXT:
    case MANUAL_PAYMENT:
    case CHECK_PAYMENT:
    case IDASTART:
    case IDANEXT:
    case NEW_CHECKIN:
    case NEW_NEXT:
    case NEW_CHECK_PAYMENT:
    case NEW_MANUAL_PAYMENT:
    case RANDOM_NEXT:
    case LAST_NEXT:
    case OFFER_CHECKIN:
    case SELECT_OFFER:
    case RESUME_APPLICATION:
      return action.status === 'done' ? { ...action.data.data } : state;
    default:
      return state;
  }
};

export const screen = combineReducers({
  checkinData,
});
